module.exports = __webpack_public_path__ + "img/1542484206.3664505e.jpg";